<!-- @component Generates an SVG line shape. -->
<script>
  import { getContext } from "svelte";
  import { raise } from "layercake";
  import { urbanColors } from "@urbaninstitute/dataviz-components/utils";
  import { line, curveLinear } from "d3-shape";

  const { data, xGet, yScale, yDomain, yRange } = getContext("LayerCake");

  const {
    key,
    dataSet,
    dash = false,
    points = false,
    fill = urbanColors.blue,
    hover = false,
    strokeWidth = 2,
    inactive = false,
    missing = false,
    curve = curveLinear
  } = $props();

  // hold element referencee
  let el = $state();

  function yGet(d) {
    return $yScale(d[key]);
  }

  function cleanPath(pathString) {
    let result = pathString.replaceAll("ML", "M");
    if (!result.startsWith("M")) {
      result = "M" + result;
    }
    if (result.endsWith("M")) {
      return result.slice(0, -1);
    } else {
      return result;
    }
  }

  let path = $derived((d) => {
    let result = line()
      .defined((d) => !isNaN(yGet(d)))
      .x($xGet)
      .y(yGet)
      .curve(curve)(d);
    return result;
  });

  let dataNoMissing = $derived(dataSet.filter((d) => !isNaN(yGet(d))));
  let pathMissing = $derived(path(dataNoMissing));

  let pathGaps = $derived(path(dataSet));
  let isActive = $derived(hover);

  $effect(() => {
    if (hover) {
      raise(el);
    }
    if (!inactive) {
      raise(el);
    }
  });
</script>

<g
  class="line"
  data-geoid={key}
  bind:this={el}
  class:inactive
  style={`--stroke-width=${strokeWidth}`}
>
  <!-- line -->
  {#if missing}
    <path
      class="path-line"
      d={pathMissing}
      stroke={fill}
      stroke-width={strokeWidth}
      stroke-dasharray="4 4"
    ></path>
  {/if}
  {#if isActive || dash}
    <path class="path-line-outline" d={pathGaps} stroke={"white"} stroke-width={strokeWidth + 3}
    ></path>
  {/if}
  <path class="path-line" class:dash d={pathGaps} stroke={fill} stroke-width={strokeWidth}></path>
  {#if points}
    <!-- points -->
    {#each dataSet as d, i}
      {#if !isNaN(yGet(d))}
        <circle cx={$xGet(d)} cy={yGet(d)} r="3" {fill} />
      {/if}
    {/each}
  {/if}
</g>

<style>
  .line {
    opacity: 1;
    transition: opacity 100ms;
  }
  .line.inactive {
    opacity: 0.5;
  }
  .path-line.dash {
    stroke-dasharray: 10, 5;
  }
  .path-line {
    fill: none;
    stroke-linejoin: round;
    stroke-linecap: round;
  }
  .path-line-outline {
    fill: none;
    stroke-linejoin: round;
    stroke-linecap: round;
    stroke-width: 5;
  }

  circle {
    cursor: pointer;
  }
</style>
